import ReportView, { type ReportColumn } from '../../../components/reports/ReportView';
import { useConfig, listOptions } from '../../../context/ConfigContext';

// TS port of the source (Falah) app's pages/reports/resources/FacilityDirectoryReport.jsx.
const COLUMNS: ReportColumn[] = [
  { key: 'name', label: 'Facility' },
  { key: 'building', label: 'Building' },
  { key: 'floor', label: 'Floor' },
  { key: 'capacity', label: 'Capacity', align: 'right' },
  { key: 'status', label: 'Status' },
  { key: 'maintenance_notes', label: 'Maintenance Notes' },
];

export function FacilityDirectoryReport() {
  const { lists } = useConfig();

  return (
    <ReportView
      title="Facility Directory"
      description="Facilities with building, floor, capacity and status."
      endpoint="/reports/resources/facility-directory"
      columns={COLUMNS}
      filters={['status']}
      statusOptions={listOptions(lists, 'facility_status')}
    />
  );
}
